import * as Sentry from '@sentry/react';

const logException = (err, errInfo = {}) => {
    if (typeof window !== 'undefined') {
        Sentry.captureException(err, errInfo);
    }
};

export default { logException };
